export default __webpack_public_path__ + "static/media/splatter.dcdd205ea342dbb3ac382ffe16a0ba79.svg";